import { BaseModel } from '@Core';

export enum EnableStatus {
    Disable,
    Enable,
}

export enum IntervalUnit {
    Millisecond,
    Second,
    Minute,
    Hour,
    Day,
}

export interface PMC8266NotifyConfig {
    Index: number;
    Enable: EnableStatus;
    Url: string;
    User: string;
    Password: string;
}

export interface PMC8266ScheduleConfig {
    ScheduleIndex: number;
    Schedule: string;
}

export interface PMC8266SnapshotSetting extends BaseModel {
    TimingSnapshotEnable?: EnableStatus;
    IntervalValue?: number;
    IntervalUnit?: IntervalUnit;
    SaveIntoStorage?: EnableStatus;
    UploadViaFtp?: EnableStatus;
    UploadViaSmtp?: EnableStatus;
    UploadViaHttp?: EnableStatus;

    NotifyList?: PMC8266NotifyConfig[];

    ScheduleList?: PMC8266ScheduleConfig[];
}
